export const GET_FRIENDS_VIEW = 'GET_FRIENDS_VIEW'
export const UPDATE_FRIENDS_VIEW = 'UPDATE_FRIENDS_VIEW'
